import { PrivacyTypes, ProfileV2 } from '../../types';

function showLocationFoundInCv({
  suburb,
  state,
  country,
  profilePrivacy,
}: ProfileV2): boolean {
  return (
    [suburb, state, country].filter(Boolean).join(', ') !== '' &&
    profilePrivacy === PrivacyTypes.Standard
  );
}

export default showLocationFoundInCv;
